// extracted by mini-css-extract-plugin
export var articleTagListContainer = "article-tag-list-module--article-tag-list-container--07VNp";